var map = {
	"./cagayan-cert.webp": 1963,
	"./cert-bg.webp": 1964,
	"./isle-cert.webp": 1965,
	"./license-bg-cn.webp": 1966,
	"./license-bg-mobile-cn.webp": 1967,
	"./license-bg-mobile.webp": 1968,
	"./license-bg.webp": 1969,
	"./pagcor-cert.webp": 1970,
	"./page-bg.webp": 1971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 900;